
export function initSubHeaderMenu() {
    const subHeaderToggle = document.querySelector('.js-toggleSubHeader');
    const subHeaderNavigation = document.querySelector('.js-subHeaderNavigation');

    if (!subHeaderToggle || !subHeaderNavigation) {
        return;
    }

    // Mobil oeffnet/schliesst die Subheader-Ueberschrift die Subnavigation
    // statt auf die Uebersichtsseite zu navigieren. Der Link darf dabei nicht
    // ausgefuehrt werden, sonst verlaesst man die Seite. Ab Desktop (>= md)
    // bleibt die Ueberschrift ein normaler Link, dort ist der Toggle-Button
    // ausgeblendet. (#227066)
    document.querySelector('.dcSubHeader__headline')?.addEventListener('click', (event) => {
        if (window.innerWidth >= 1024) {
            return;
        }

        event.preventDefault();
        subHeaderToggle.click();
    });

    subHeaderToggle.addEventListener('click', () => {
        const isOpen = subHeaderNavigation.classList.toggle('is-open');
        subHeaderToggle.classList.toggle('is-active');
        document.body.classList.toggle('is-subheaderopen');
        document.body.classList.remove('is-headerpanelopen');
        // Der Zustand muss auch angesagt werden, nicht nur ueber Klassen
        // sichtbar sein (dcLens 27.08.2026, a11y/button-name).
        subHeaderToggle.setAttribute('aria-expanded', String(isOpen));
    });
}
